module.exports = __webpack_public_path__ + "static/media/icons8-plus.0fbccd9a.svg";